// extracted by mini-css-extract-plugin
module.exports = {"tab":"style_tab__3Ijoa","tooltip--content":"style_tooltip--content__lGql7","tooltip--trigger":"style_tooltip--trigger__bPryz"};